export default function toTask(schedulingStrategy, signal) {
    const options = {
        interactive: {
            type: 'frame-based',
            workTime: 83,
            priority: 30,
        },
        smooth: {
            type: 'frame-based',
            workTime: 13,
            priority: 20,
        },
        idle: {
            type: 'idle-based',
            workTime: 5,
            priority: 10,
        },
    };
    const task = options[schedulingStrategy];
    task.signal = signal;
    return task;
}
